<template>
    <div class="form-group row" :class="formGroupStyles">
        <slot name="label"/>
        <div :class="fieldParentClasses ? fieldParentClasses : 'col-12 col-sm-10'">
            <slot name="field"/>
            <div class="form-control-feedback" v-for="msg in errors">{{ msg }}</div>
        </div>
    </div>
</template>

<!-- Use fieldParentClasses if label is not col-sm-2 -->

<script>

    export default {
        props: ['errors', 'fieldParentClasses'],

        computed: {
            formGroupStyles() {
                return this.errors ? 'has-danger' : '';
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Forms/FormGroupHorizontal.vue